import type { Address } from '$types/address';
import { browser } from '$app/environment';

/**
 * Use this method in authenticated places.
 * If you expect null value, use localStorage directly.
 */
export const getMetriAddress = () => {
  if (!browser) {
    return '0x0';
  }

  const address = localStorage.getItem('metriAddress');

  return address as Address;
};
